import * as types from 'store/mutation-types'
import mqtt from 'utils/mqtt'
const state = {
  mqttTime: null,
  connected: false
}
const getters = {
  mqttConnectTime(state) {
    return state.mqttTime
  },
  mqttConnected(state) {
    return state.connected
  }
}
const mutations = {
  [types.MQTT_CONNECT](state) {
    state.mqttTime = new Date().getTime()
    state.connected = true
  },
  [types.MQTT_DISCONNECT](state) {
    state.mqttTime = null
    state.connected = false
  }
}
const actions = {
  connectMqtt({ getters, commit }) {
    if (mqtt.connected) mqtt.disconnect()
    mqtt.connect(getters.uuid, getters.token)
    mqtt.on('connect', function connect() {
      commit(types.MQTT_CONNECT, new Date().getTime())
      if (mqtt.subscribers.size === 0) return
      for (const key of mqtt.subscribers.keys()) {
        mqtt.subscribe(key)
      }
      mqtt.off('connect', connect)
    })
  },
  disconnectMqtt({ commit }) {
    if (mqtt.connected) {
      mqtt.on('close', function close() {
        commit(types.MQTT_DISCONNECT)
        mqtt.off('close', close)
      })
      mqtt.disconnect()
    }
  }
}
export default {
  state,
  actions,
  mutations,
  getters
}
